var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"sort-btn",class:{ 'is-active': _vm.isActive },attrs:{"title":_vm.isAsc
      ? 'Сортировать по возрастанию'
      : _vm.isDesc
      ? 'Сортировать по убыванию'
      : `Сортировать по ${_vm.sortField}`},on:{"click":_vm.handleClick}},[_c('v-icon',{attrs:{"small":"","left":"","color":_vm.isActive ? 'primary' : 'grey lighten-1'}},[_vm._v(_vm._s(_vm.isAsc ? "mdi-sort-ascending" : _vm.isDesc ? "mdi-sort-descending" : "mdi-sort"))]),_vm._v(" "),_c('span',{staticClass:"sort-btn__label"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.sortField))]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }